import { isNullish } from "./isNullish";
export var isNonEmptyObject = function (value) {
    // Check if the value is an object and not null
    if (typeof value === "object" && !isNullish(value)) {
        // Check if the object has any own properties
        return Object.keys(value).length > 0;
    }
    return false;
};
